const installationKey = Symbol.for("erp.turboProgressGuardInstalled")

const documentIsBusy = () => {
  if (document.documentElement.getAttribute("aria-busy") === "true") return true

  return document.querySelector("form[aria-busy='true']") !== null
}

export const installTurboProgressGuard = (Turbo) => {
  const navigator = Turbo.navigator
  const adapter = navigator?.adapter
  if (!navigator || !adapter || navigator[installationKey]) return

  navigator[installationKey] = true

  // Turbo leaves a delayed progress timer behind when a visit is interrupted.
  const originalStop = navigator.stop.bind(navigator)
  navigator.stop = function () {
    if (this.currentVisit) adapter.hideVisitProgressBar?.()
    if (this.formSubmission) adapter.hideFormProgressBar?.()

    return originalStop()
  }

  const finishSettledProgress = () => {
    queueMicrotask(() => {
      if (documentIsBusy()) return

      adapter.progressBar?.setValue(1)
      adapter.hideVisitProgressBar?.()
      adapter.hideFormProgressBar?.()
    })
  }

  document.addEventListener("turbo:load", finishSettledProgress)
  window.addEventListener("pageshow", finishSettledProgress)

  let pendingReload
  document.addEventListener("turbo:before-visit", () => {
    if (pendingReload === undefined) return

    window.clearTimeout(pendingReload)
    pendingReload = undefined
  })

  Turbo.StreamActions.reload = function () {
    if (pendingReload !== undefined) return

    const location = window.location.href
    pendingReload = window.setTimeout(() => {
      pendingReload = undefined
      Turbo.visit(location, { action: "replace" })
    }, 0)
  }
}
